import { Card } from '@/components/ui/card';
import { HelpCircle, Wallet, ShoppingBag, Users, Shield, MessageCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

const faqData = [
  {
    category: 'Cuenta y Acceso',
    icon: Shield,
    items: [
      { q: 'Como me registro?', a: 'Haz clic en "Registrate" en la pagina de login. Completa tu nombre, email y contrasena. Si tienes un codigo de referido, introducelo para ganar puntos.' },
      { q: 'Olvide mi contrasena, que hago?', a: 'Contacta a nuestro equipo de soporte via WhatsApp para restablecer tu contrasena.' },
      { q: 'Que es el PIN de seguridad?', a: 'Es un codigo de 4 digitos que puedes configurar en la seccion de Seguridad para proteger tus operaciones sensibles.' },
      { q: 'Mi cuenta fue bloqueada, por que?', a: 'Si ingresas la contrasena incorrecta 5 veces seguidas, tu cuenta se bloquea por 15 minutos por seguridad.' },
    ]
  },
  {
    category: 'Wallet y Recargas',
    icon: Wallet,
    items: [
      { q: 'Como recargo mi wallet?', a: 'Ve a "Mi Wallet" > "Recargar". Selecciona un metodo de pago, realiza la transferencia y sube la foto del comprobante. Un administrador aprobara tu recarga.' },
      { q: 'Cuanto tarda en aprobarse una recarga?', a: 'Normalmente entre 5 minutos y 2 horas en horario laboral. En dias festivos puede tardar un poco mas.' },
      { q: 'Puedo obtener un reembolso?', a: 'Si, si un servicio es cancelado, el monto se reintegra automaticamente a tu wallet.' },
      { q: 'Hay limites de transacciones?', a: 'Si, existen limites diarios y semanales configurados por el administrador. Puedes verlos en la seccion de Seguridad.' },
    ]
  },
  {
    category: 'Servicios y Ordenes',
    icon: ShoppingBag,
    items: [
      { q: 'Como solicito un servicio?', a: 'Ve a "Servicios", selecciona el que necesitas, completa los detalles y confirma. El monto se descontara de tu wallet.' },
      { q: 'Cuales son los estados de una orden?', a: 'Pendiente (recibida), En Proceso (siendo atendida) y Completado. Puedes ver el progreso en tiempo real.' },
      { q: 'Puedo cancelar una orden?', a: 'Contacta al administrador via chat en la orden o por WhatsApp. Si la orden no ha sido procesada, se puede cancelar y reembolsar.' },
      { q: 'Donde descargo mi comprobante?', a: 'Una vez completada tu orden, aparecera un boton "Recibo" para descargar el PDF del comprobante.' },
    ]
  },
  {
    category: 'Referidos y Puntos',
    icon: Users,
    items: [
      { q: 'Como funciona el sistema de referidos?', a: 'Comparte tu codigo unico con amigos. Cuando se registren usando tu codigo, ganas 50 puntos.' },
      { q: 'Para que sirven los puntos?', a: 'Cada 200 puntos puedes canjear un cupon de $5.00 USD de descuento en servicios.' },
      { q: 'Los cupones tienen fecha de vencimiento?', a: 'Si, los cupones vencen a los 90 dias despues de ser creados.' },
    ]
  },
  {
    category: 'Soporte',
    icon: MessageCircle,
    items: [
      { q: 'Como contacto al soporte?', a: 'Usa el boton de WhatsApp (esquina inferior derecha) o el chat dentro de cada orden para comunicarte directamente con nuestro equipo.' },
      { q: 'Cual es el horario de atencion?', a: 'Nuestro equipo esta disponible de lunes a viernes de 8:00 AM a 8:00 PM (hora local). Los fines de semana respondemos mensajes en un plazo de 4 horas.' },
    ]
  }
];

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 last:border-0">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-3 px-1 text-left hover:bg-slate-50 rounded-lg transition-colors" data-testid={`faq-q`}>
        <span className="text-sm font-medium text-slate-800">{q}</span>
        {open ? <ChevronUp className="w-4 h-4 text-slate-400 shrink-0" /> : <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />}
      </button>
      {open && <p className="text-sm text-slate-600 pb-3 px-1 leading-relaxed">{a}</p>}
    </div>
  );
};

const ClientFaqPage = () => {
  return (
    <div className="space-y-6" data-testid="client-faq-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Centro de Ayuda</h1>
        <p className="text-slate-500">Encuentra respuestas a las preguntas mas frecuentes</p>
      </div>

      {faqData.map((section) => (
        <Card key={section.category} className="p-5 border-0 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 rounded-xl bg-emerald-100 flex items-center justify-center">
              <section.icon className="w-5 h-5 text-emerald-600" />
            </div>
            <h2 className="font-semibold text-slate-900">{section.category}</h2>
          </div>
          <div className="space-y-0">
            {section.items.map((item) => (
              <FaqItem key={item.q} {...item} />
            ))}
          </div>
        </Card>
      ))}

      <Card className="p-6 border-0 shadow-sm bg-emerald-50 text-center">
        <HelpCircle className="w-8 h-8 mx-auto text-emerald-500 mb-2" />
        <p className="text-sm text-emerald-700">No encuentras lo que buscas? Contacta a nuestro equipo por WhatsApp</p>
      </Card>
    </div>
  );
};

export default ClientFaqPage;
